var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.438 24V12.97h3.833l.574-3.958h-4.407v-2.95c0-1.235.358-2.077 2.205-2.077L18 3.984V.168C17.592.116 16.194 0 14.566 0 11.17 0 9.067 1.988 9.067 5.64v3.372H5.046v3.959h4.021V24z"
})));
export default SvgFacebookinline;